import styled from 'styled-components';

export const AdditionalLink = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.gap(3)};
`;
